import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { useReviews } from 'marketplace-ui-reviews/hooks/useReviews';
import ReviewsPaginatedList from 'marketplace-ui-reviews/components/ReviewsPaginatedList';
import ReviewFilters from 'marketplace-ui-reviews/records/ReviewFilters';
import ReviewsListStats from 'marketplace-ui-reviews/components/ReviewsListStats';
import { WriteReviewButton } from 'marketplace-ui-reviews/components/WriteReviewButton';
import { useDetailsPageContext } from '../../context/DetailsPageContext';
import { DetailsPageCard } from './DetailsPageCard';
import ReviewRenderer from '../../reviews/ReviewRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductReviewsCard({
  productId
}) {
  const {
    productType
  } = useDetailsPageContext();
  if (productType === 'AGENT') {
    return null;
  }
  return /*#__PURE__*/_jsx(ReviewsCard, {
    productId: productId
  });
}
function ReviewsCard({
  productId
}) {
  const {
    appContext,
    productType
  } = useDetailsPageContext();
  // @ts-expect-error We don't render this card for agents
  const reviewType = productType;
  const [showPagination, setShowPagination] = useState(false);
  const [reviewFilters, setReviewFilters] = useState(new ReviewFilters({
    entityId: productId,
    limit: 2
  }));

  // TODO: Fetch review summary with query
  const reviewSummary = null;
  const {
    reviews,
    reviewsFetchStatus,
    reviewStats,
    reviewsTotal
  } = useReviews({
    appContext,
    reviewFilters,
    offeringId: productId,
    reviewType
  });
  const handleUpdateFilters = useCallback(updates => {
    let newReviewFilters = reviewFilters.updateFilters(updates);
    if (!updates.page) {
      newReviewFilters = newReviewFilters.updateFilters({
        page: 1
      });
    }
    setReviewFilters(newReviewFilters);
  }, [reviewFilters]);
  return /*#__PURE__*/_jsx(DetailsPageCard, {
    id: "details-page-reviews",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.reviewsCard.title"
    }),
    actions: /*#__PURE__*/_jsx(WriteReviewButton, {
      disabled: false,
      hasEditableReview: false
      // TODO: handle linking to inApp review flow for public
      // TODO: handle opening ReviewWizard for logged in users
      ,
      onClick: () => {},
      size: "sm",
      unreviewableReason: null,
      reviewPending: false
    }),
    children: /*#__PURE__*/_jsxs(Grid, {
      gap: "600",
      children: [!!reviewStats.count && reviewStats.count > 3 && /*#__PURE__*/_jsx(GridItem, {
        size: 12,
        children: /*#__PURE__*/_jsx(ReviewsListStats, {
          hideQualityRatings: true,
          inline: true,
          onUpdateFilters: () => {},
          reviewStats: reviewStats,
          reviewType: reviewStats.reviewType
        })
      }), /*#__PURE__*/_jsxs(GridItem, {
        size: 12,
        children: [!!reviewSummary && /*#__PURE__*/_jsxs(View, {
          backgroundColor: "fill-surface-raised",
          borderRadius: "200",
          padding: "800",
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            inlineSize: "100%",
            justifyContent: "space-between",
            marginBlockEnd: "400",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "small",
              color: "text-core-subtle",
              typography: "heading-25",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.reviewsCard.summarizedWithAI"
              })
            }), /*#__PURE__*/_jsx(AIBadge, {})]
          }), /*#__PURE__*/_jsx(Text, {
            children: reviewSummary
          })]
        }), /*#__PURE__*/_jsx(ReviewsPaginatedList, {
          onUpdateFilters: ({
            textKey,
            value
          }) => {
            handleUpdateFilters({
              [textKey]: value
            });
            // if (textKey === SEARCH_KEY) {
            //   setSearchTerm(String(value));
            // }
          },
          reviews: reviews,
          reviewsFetchStatus: reviewsFetchStatus,
          reviewFilters: reviewFilters,
          ReviewRenderer: ReviewRenderer,
          reviewsTotal: reviewsTotal,
          reviewsPerPage: reviewFilters.limit,
          showPagination: showPagination,
          pageLimitOptions: [5, 10, 20]
        }), !showPagination && /*#__PURE__*/_jsx(Button, {
          onClick: () => {
            setShowPagination(true);
            handleUpdateFilters({
              limit: 5
            });
          },
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.reviewsCard.seeAll"
          })
        })]
      })]
    })
  });
}